import React from "react";
import NavbarRibbon from "../components/Navbar/NavbarRibbon";
import { default as NavbarComponent } from "../components/Navbar/Navbar";
import { Container } from "reactstrap";
import { GatewayToolApp } from "../components/GatewayForm/GatewayForm";

const Navbar = () => {
  const isSearch = window.location.search.includes("?s=") || window.location.search.includes("&s=");
  const isHomepage = window.location.pathname === "/" && !isSearch;
  return (
    <div style={{ background: "white" }}>
      <Container>
        {isHomepage ? <NavbarRibbon /> : null}
        {/* <Navbar /> */}
        <NavbarComponent />
        <GatewayToolApp />
      </Container>
    </div>
  );
};

export default Navbar;
